export default __webpack_public_path__ + "static/media/bernay19.43f05c04.jpg";